var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PmwParagraph',{attrs:{"size":"paragraph-80","weight":"light"}},[_vm._v(" "+_vm._s(_vm.formatedDates)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }